'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function get(url, callback) {
    return _request2.default.get({
        url: location.origin + url
    }, function (err, res, body) {
        if (err) {
            console.warn(err);
            return [];
        }

        callback(JSON.parse(body));
    });
}

function formatCurrency(value) {
    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GBP';

    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        currencyDisplay: 'symbol'
    }).format(value);
}

var BrandSummary = function (_React$Component) {
    _inherits(BrandSummary, _React$Component);

    function BrandSummary(props) {
        _classCallCheck(this, BrandSummary);

        var _this = _possibleConstructorReturn(this, (BrandSummary.__proto__ || Object.getPrototypeOf(BrandSummary)).call(this, props));

        _this.state = {
            options: {
                brands: [],
                regions: [],
                store_types: [],
                store_category: [],
                status: [],
                seasons: [],
                years: [{
                    label: '2017',
                    value: '17'
                }, {
                    label: '2018',
                    value: '18'
                }, {
                    label: '2019',
                    value: '19'
                }]
            },
            selected: {
                brand: null,
                territory: null,
                type: null,
                category: null,
                status: null,
                season_start: null,
                season_end: null
            },
            isLoading: false,
            data: {
                stores: []
            },
            budget: {
                years: {},
                seasons: {},
                main_seasons: {}
            }
        };

        _this.loadData = _this.loadData.bind(_this);
        _this.loadOptions = _this.loadOptions.bind(_this);
        _this.selectOption = _this.selectOption.bind(_this);
        _this.getData = _this.getData.bind(_this);
        _this.getMainData = _this.getMainData.bind(_this);
        _this.getBudgetData = _this.getBudgetData.bind(_this);
        _this.renderStores = _this.renderStores.bind(_this);
        _this.renderSeasonsForRow = _this.renderSeasonsForRow.bind(_this);
        _this.renderIntro = _this.renderIntro.bind(_this);
        _this.renderOptions = _this.renderOptions.bind(_this);
        _this.renderReportHeader = _this.renderReportHeader.bind(_this);
        _this.renderReportData = _this.renderReportData.bind(_this);
        _this.setInitialValue = _this.setInitialValue.bind(_this);
        _this.updateHash = _this.updateHash.bind(_this);

        return _this;
    }

    _createClass(BrandSummary, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var params = {};
            if (document.location.hash.length > 1) {
                document.location.hash.substr(1).split('&').forEach(function (item) {
                    var values = item.split('=');
                    params[values[0]] = { value: decodeURIComponent(values[1]) };
                });
                this.setState({
                    selected: params
                }, function () {
                    _this2.loadData();
                    _this2.getData();
                });
            } else {
                this.loadData();
            }
        }
    }, {
        key: 'updateHash',
        value: function updateHash() {
            var selected = this.state.selected;

            var keys = Object.keys(selected);
            var hashString = keys.map(function (key) {
                if (!key) return null;
                if (!selected[key]) return null;
                return key + '=' + encodeURIComponent(selected[key].value);
            }).filter(function (item) {
                return item !== null;
            }).join('&');

            document.location.hash = hashString;
        }
    }, {
        key: 'setInitialValue',
        value: function setInitialValue(data, key) {
            var id = this.state.selected[key].value;
            var value = null;

            for (var i = 0; i < data.length; i++) {
                if (data[i].value == id) {
                    value = data[i];
                }
            }

            this.setState({
                selected: _extends({}, this.state.selected, _defineProperty({}, key, value))
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.loadOptions('brands');
            this.loadOptions('regions');
            this.loadOptions('store_types');
            this.loadOptions('store_category');
            this.loadOptions('seasons');
        }
    }, {
        key: 'loadOptions',
        value: function loadOptions(key) {
            var _this3 = this;

            var url = '/ajax/' + key;
            get(url, function (data) {
                if (key === 'brands') {
                    if (_this3.state.selected.brand) _this3.setInitialValue(data, 'brand');
                }
                if (key === 'regions') {
                    if (_this3.state.selected.territory) _this3.setInitialValue(data, 'territory');
                }
                if (key === 'store_category') {
                    if (_this3.state.selected.category) _this3.setInitialValue(data, 'category');
                }
                if (key === 'store_types') {
                    if (_this3.state.selected.type) _this3.setInitialValue(data, 'type');
                }
                _this3.setState({
                    options: _extends({}, _this3.state.options, _defineProperty({}, key, data))
                }, function () {});
            });
        }
    }, {
        key: 'selectOption',
        value: function selectOption(key) {
            var _this4 = this;

            return function (value) {
                var selected = _this4.state.selected;

                selected[key] = value;
                _this4.setState({
                    selected: selected
                }, function () {
                    _this4.updateHash();
                    _this4.getData();
                });
            };
        }
    }, {
        key: 'getData',
        value: function getData() {
            var brand = this.state.selected.brand;

            if (!brand) return;
            this.getMainData();
            this.getBudgetData();
        }
    }, {
        key: 'getMainData',
        value: function getMainData() {
            var _this5 = this;

            var _state$selected = this.state.selected,
                brand = _state$selected.brand,
                territory = _state$selected.territory,
                category = _state$selected.category,
                type = _state$selected.type;

            if (!brand) return;

            var url = '/ajax/data/brand_summary?brand_id=' + brand.value + '&region_id=' + (territory ? territory.value : '') + '&store_category=' + (category ? category.value : '') + '&store_type=' + (type ? type.value : '');

            this.setState({
                isLoading: true
            });
            get(url, function (data) {
                _this5.setState({
                    isLoading: false,
                    data: data
                });
            });
        }
    }, {
        key: 'getBudgetData',
        value: function getBudgetData() {
            var _this6 = this;

            var brand = this.state.selected.brand;

            if (!brand) return;

            var url = '/ajax/data/brand_budget/' + brand.value;
            this.setState({
                isLoadingBudgets: true
            });
            get(url, function (budget) {
                _this6.setState({
                    isLoadingBudgets: false,
                    budget: budget
                });
            });
        }
    }, {
        key: 'renderReportHeader',
        value: function renderReportHeader() {
            var _state$selected2 = this.state.selected,
                brand = _state$selected2.brand,
                territory = _state$selected2.territory,
                category = _state$selected2.category,
                type = _state$selected2.type;

            var filters = [];
            if (territory && territory.label) {
                filters.push(territory.label);
            }
            if (category && category.label) {
                filters.push(category.label);
            }
            if (type && type.label) {
                filters.push(type.label);
            }
            return _react2.default.createElement(
                'div',
                { className: 'brand-summary-header' },
                _react2.default.createElement(
                    'h1',
                    null,
                    brand && brand.label ? brand.label + ' ' : '',
                    _react2.default.createElement(
                        'span',
                        null,
                        'Brand Summary'
                    )
                ),
                _react2.default.createElement(
                    'h3',
                    { className: 'filters' },
                    filters.join(', ')
                )
            );
        }
    }, {
        key: 'renderStores',
        value: function renderStores() {
            var _this7 = this;

            var data = this.state.data;

            var stores = Object.keys(data.stores);

            return _react2.default.createElement(
                'div',
                null,
                stores.map(function (key, i) {
                    var row = data.stores[key];
                    return _react2.default.createElement(
                        'div',
                        { className: 'store-row', key: i },
                        _react2.default.createElement(
                            'div',
                            { className: 'name' },
                            row.name
                        ),
                        _this7.renderSeasonsForRow(row)
                    );
                })
            );
        }
    }, {
        key: 'renderSeasonsForRow',
        value: function renderSeasonsForRow(row) {
            var _this8 = this;

            var years = this.state.options.years;


            return _react2.default.createElement(
                'div',
                { className: 'seasons' },
                years.map(function (_ref) {
                    var value = _ref.value;

                    return _react2.default.createElement(
                        'div',
                        { className: 'year', key: value },
                        _this8.renderSeason('PS' + value, row),
                        _this8.renderSeason('SS' + value, row),
                        _this8.renderSeason('PA' + value, row),
                        _this8.renderSeason('AW' + value, row)
                    );
                })
            );
        }
    }, {
        key: 'renderSeason',
        value: function renderSeason(season, row) {
            var value = row.seasons[season] && row.seasons[season].value;
            value = value ? formatCurrency(value) : null;
            return _react2.default.createElement(
                'div',
                { className: 'season' },
                value
            );
        }
    }, {
        key: 'renderTableHeader',
        value: function renderTableHeader() {
            var years = this.state.options.years;

            return [_react2.default.createElement(
                'div',
                { className: 'store-row header', key: 'h1' },
                _react2.default.createElement(
                    'div',
                    { className: 'name' },
                    'Store'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'seasons' },
                    years.map(function (_ref2) {
                        var label = _ref2.label;
                        return _react2.default.createElement(
                            'div',
                            { className: 'year', key: label },
                            label
                        );
                    })
                )
            ), _react2.default.createElement(
                'div',
                { className: 'store-row sub-header', key: 'h2' },
                _react2.default.createElement('div', { className: 'name' }),
                _react2.default.createElement(
                    'div',
                    { className: 'seasons' },
                    years.map(function (_ref3) {
                        var value = _ref3.value;
                        return _react2.default.createElement(
                            'div',
                            { className: 'year', key: value },
                            _react2.default.createElement(
                                'div',
                                { className: 'season' },
                                'PS',
                                value
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'season' },
                                'SS',
                                value
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'season' },
                                'PA',
                                value
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'season' },
                                'AW',
                                value
                            )
                        );
                    })
                )
            )];
        }
    }, {
        key: 'renderIntro',
        value: function renderIntro() {
            var _this9 = this;

            var _state = this.state,
                data = _state.data,
                brand = _state.selected.brand;
            var budget = this.state.budget;

            if (!data.years || !brand) return null;

            return _react2.default.createElement(
                'div',
                { className: 'intro' },
                Object.keys(data.years).sort().reverse().map(function (year) {
                    return _this9.renderIntroYear(year, data, budget);
                })
            );
        }
    }, {
        key: 'renderIntroYear',
        value: function renderIntroYear(year, orders, budgets) {
            var orderValue = orders.years[year];
            if (!orderValue) return null;
            var orderValueLastYear = orders.years[year - 1];
            var yoy = '';
            if (orderValueLastYear) {
                var diff = orderValue / orderValueLastYear * 100 - 100;
                if (diff >= 0) yoy = '+ ' + Math.round(diff, 2) + '%';else yoy = '- ' + Math.round(diff, 2) + '%';
            }

            var sskey = 'SS' + (year - 2000);
            var awkey = 'AW' + (year - 2000);

            return _react2.default.createElement(
                'div',
                { className: 'intro-row', key: year },
                _react2.default.createElement(
                    'div',
                    { className: 'year' },
                    year
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'data' },
                    _react2.default.createElement(
                        'div',
                        { className: 'data-label' },
                        'Confirmed Orders'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'value order-value' },
                        formatCurrency(orderValue)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'diff' },
                        yoy
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'data-label budget-label' },
                        'Budget'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'value budget-value' },
                        budgets.years[year] ? formatCurrency(budgets.years[year]) : '–'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'season' },
                    _react2.default.createElement(
                        'div',
                        { className: 'season-label' },
                        'Spring / Summer'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'data' },
                    _react2.default.createElement(
                        'div',
                        { className: 'data-label' },
                        'Confirmed Orders'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'value order-value' },
                        orders.seasons[sskey] ? formatCurrency(orders.seasons[sskey]) : '–'
                    ),
                    _react2.default.createElement('div', { className: 'diff' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'data-label budget-label' },
                        'Budget'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'value budget-value' },
                        budgets.seasons[sskey] ? formatCurrency(budgets.seasons[sskey]) : '–'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'season' },
                    _react2.default.createElement(
                        'div',
                        { className: 'season-label' },
                        'Autumn / Winter'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'data' },
                    _react2.default.createElement(
                        'div',
                        { className: 'data-label' },
                        'Confirmed Orders'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'value order-value' },
                        orders.seasons[awkey] ? formatCurrency(orders.seasons[awkey]) : '–'
                    ),
                    _react2.default.createElement('div', { className: 'diff' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'data-label budget-label' },
                        'Budget'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'value budget-value' },
                        budgets.seasons[awkey] ? formatCurrency(budgets.seasons[awkey]) : '–'
                    )
                )
            );
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var _state$options = this.state.options,
                brands = _state$options.brands,
                store_types = _state$options.store_types,
                store_category = _state$options.store_category,
                regions = _state$options.regions;
            var selected = this.state.selected;


            return _react2.default.createElement(
                'div',
                { className: 'options' },
                _react2.default.createElement(
                    'div',
                    { className: 'options-row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cell' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Brand'
                        ),
                        _react2.default.createElement(_reactSelect2.default, {
                            options: brands,
                            value: selected.brand,
                            onChange: this.selectOption('brand')
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'options-row second-row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cell' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Territory'
                        ),
                        _react2.default.createElement(_reactSelect2.default, {
                            options: regions,
                            value: selected.territory,
                            onChange: this.selectOption('territory')
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cell' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Store Category'
                        ),
                        _react2.default.createElement(_reactSelect2.default, {
                            options: store_category,
                            value: selected.category,
                            onChange: this.selectOption('category')
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cell' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Store Type'
                        ),
                        _react2.default.createElement(_reactSelect2.default, {
                            options: store_types,
                            value: selected.type,
                            onChange: this.selectOption('type')
                        })
                    )
                )
            );
        }
    }, {
        key: 'renderReportData',
        value: function renderReportData() {
            if (!this.state.data.stores || !this.state.selected.brand) return null;

            return _react2.default.createElement(
                'div',
                null,
                this.renderTableHeader(),
                this.renderStores()
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                selected = _state2.selected,
                brands = _state2.options.brands;


            return _react2.default.createElement(
                'div',
                null,
                this.renderReportHeader(),
                this.renderOptions(),
                this.renderIntro(),
                this.renderReportData()
            );
        }
    }]);

    return BrandSummary;
}(_react2.default.Component);

exports.default = BrandSummary;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/reports/BrandSummary.js
// module id = 518
// module chunks = 0